import React from "react";
import { toAbsoluteUrl } from "../../../_helpers";

export function Brand() {
   return (
      <>
         {/* begin::Brand */}
         <div className={`aside-brand d-flex flex-column flex-column-auto py-5 py-lg-12 pl-18`}>
            {/* begin::Logo */}
            <div className="brand-logo ">
               <img
                  alt="logo"
                  src={toAbsoluteUrl("/media/logos/sidebar-kapsurvey-logo.png")}
                  className="max-h-35px"
               />
            </div>
            {/* end::Logo */}
         </div>
         {/* end::Brand */}
      </>
   );
}
